import { render, staticRenderFns } from "./WebhookSubscribersTab.vue?vue&type=template&id=f195a6ba&"
import script from "./WebhookSubscribersTab.vue?vue&type=script&lang=js&"
export * from "./WebhookSubscribersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports